import { render } from "./CloverSettingsTab.vue?vue&type=template&id=a3757800&scoped=true"
import script from "./CloverSettingsTab.vue?vue&type=script&lang=js"
export * from "./CloverSettingsTab.vue?vue&type=script&lang=js"

import "./CloverSettingsTab.vue?vue&type=style&index=0&id=a3757800&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3757800"]])

export default __exports__